import { render } from "./MainPage.vue?vue&type=template&id=c60f3036"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Workplace\\WebFrameworks\\vuejs\\egg-picker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__